module.exports = __webpack_public_path__ + "static/media/codepen.e79e296e.svg";